import type { Scene } from '../scenes';

const modules = import.meta.glob<Record<string, unknown>>('./*.tsx', { eager: true });

export const MORE_PLACES: Scene[] = Object.values(modules)
  .flatMap((mod) => Object.values(mod))
  .filter((v): v is Scene[] => Array.isArray(v))
  .flat()
  .filter((s) => s && typeof s.id === 'string' && s.kind === 'place');
